// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1XIS_","title":"BackImages_title__3p7Ag","images":"BackImages_images__15SuN"};